import { Component, Host, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OutboxService } from 'src/app/shared/services/outbox/outbox.service';
import { FileUploadService } from 'src/app/shared/services/file-upload/file-upload.service';
import * as XLSX from 'xlsx';
import { XlsxUtilsService } from 'src/app/shared/services/xlsx-utils/xlsx-utils.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { OutboxRequestCreationComponent } from '../outbox-request-creation.component';
import { OutboxMultiRequestUploadHistoryComponent } from '../outbox-multi-request-upload-history/outbox-multi-request-upload-history.component';
import { OutboxAfpConfigurationComponent } from '../outbox-afp-configuration/outbox-afp-configuration.component';
import { FormsModule } from '@angular/forms';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';


@Component({
  selector: 'app-outbox-multi-request-creation',
  templateUrl: './outbox-multi-request-creation.component.html',
  styleUrl: './outbox-multi-request-creation.component.scss',
  imports: [FormsModule, NgIf, NgClass, NgFor, OutboxMultiRequestUploadHistoryComponent, OutboxAfpConfigurationComponent]
})
export class OutboxMultiRequestCreationComponent {
  @ViewChild(OutboxMultiRequestUploadHistoryComponent) uploadHistoryComponent!: OutboxMultiRequestUploadHistoryComponent;
  @ViewChild(OutboxAfpConfigurationComponent) outboxAfpConfigurationComponent?: OutboxAfpConfigurationComponent;
  activeTab: string | null = 'existing_file_mapping';
  isUploadHistoryVisible: boolean = false;
  isAfpConfigVisible: boolean = false;
  isMappingDropdownDisabled: boolean = false;
  allMappingOptions: any[] = [];
  fileName: string = '';
  showModal: boolean = false;
  modalName: string = "";
  modalHeader: string = "NA";
  modalBody: string = "NA"
  touchpointSearchText: string = "";
  isFormValid: boolean = false;
  isValidConfigName: boolean = true;
  dataTypes = {}
  hasPhone = false;
  hasEmail = false;
  hasTouchpointInfo = false;
  hasCustomerId = false;
  configs = {}
  errorMsgs = {};
  request_mode: string = "upload_file";
  // touchpoint drp
  isTouchpointDropdownOpen: boolean = false;
  selectedTouchpoint: any = null;
  recaptchaToken: any;

  // selectedOption: string | null = null;
  // file map drp
  dropdownFocusState: { [header: string]: boolean } = {};
  isFileMappingDropdownOpen: boolean = false;
  selectedFileMapping: any = null;
  fileMapConfig: any[] = [];

  showPreview: boolean = false;
  brandId: string | null = null;
  afpConfigs: any | []

  // todo - ex. list of touchpoints
  touchpointOptions: any[] = [];
  brandDetail: any = {}
  // File upload object with additional properties
  fileUploadVm: any = {
    pageNumber: 1,
    isLastPage: false,
    isJobsListEmpty: false,
    pagerBusy: false,
    uploading: false,
    processing: false,
    isExistingMapping: false,
    brandDetail: null,
    brandOffset: 0,
    oldConfigName: "",
    newConfigName: "",
    touchpointDataFromOrgNode: null,
    isEmptyPage: false,
    showDefaultConfirmationBox: false,
    isExcludedFromAnalytics: false,
    isWhatsappSameAsPhone: false,
    configurations: null,
    errorMessage: "",

    // Adding fileData inside fileUploadVm
    fileData: {
      new_mappings: {},
      fileHeaders: [],
      selectedConfig: "",
    },
    defaults: {},
    headerSelect: {},
    currentMappingOptions: [],
    configList: [],
    // Code for File Upload Module Starts Here
    shops: [],
    selectedShop: {},
    configMismatch: false,
    configExists: false,
    isDefaultConfig: false,
    jobsList: [],
  }



  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _outboxService: OutboxService,
    private _fileUploadService: FileUploadService,
    private _xlsxUtilsService: XlsxUtilsService,
    private _toast: ToastService,
    @Host() private requestCreationComponent: OutboxRequestCreationComponent,
    private recaptchaV3Service: ReCaptchaV3Service
  ) { }


  ngOnInit() {
    this.brandDetail = Helpers?.brandDetails;
    this.route.queryParams.subscribe(params => {
      this.brandId = params['project_id'];
      this.errorMsgs = this._outboxService.getResponseMsgs("error");
      if (this.brandId) {
        this.getAFPConfigs();
      }
    });

  }

  initializeDefaults() {
    if (this.afpConfigs?.length) {
      this.activeTab = "existing_file_mapping";
    } else {
      this.activeTab = "new_file_mapping";
    }
    this.isMappingDropdownDisabled = false;
    this.fileName = ''
    this.isFormValid = false;
    this.selectedFileMapping = null;
    // this.fileUploadVm.isExcludedFromAnalytics = false;
    this.fileUploadVm.isWhatsappSameAsPhone = false;
    this.fileUploadVm.newConfigName = "";
    // this.clearTouchpointText()
    delete this.fileUploadVm.fileToUpload;
    for (var header in this.fileUploadVm.fileData.fileHeaders) {
      this.fileUploadVm.fileData = {
        new_mappings: {},
        fileHeaders: [],
        selectedConfig: "",
      }
    }
  }

  onCheckboxChange(item: any, event: Event) {
    item.checked = (event.target as HTMLInputElement).checked;
  }

  getTouchpointByKey($event) {
    this._outboxService.getTouchpointByText(this.brandDetail?._id, this.touchpointSearchText).subscribe(res => {
      this.touchpointOptions = res?.data?.shops
      if (this.touchpointOptions?.length) {
        this.isTouchpointDropdownOpen = true;
      } else {
        this.isTouchpointDropdownOpen = false;
      }
    })
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const dropdownContainer = document.querySelector('.dropdown-container');
    const clickedInside = dropdownContainer?.contains(event.target as Node);
    if (!clickedInside) {
      this.isTouchpointDropdownOpen = false;
    }
  }
  // Select option for Touchpoint
  selectTouchpoint(option: any) {
    this.fileUploadVm.selectedShop = option;
    this.touchpointSearchText = option?.name;
    this.isTouchpointDropdownOpen = false;
    this.validateForm()
  }

  clearTouchpointText() {
    this.touchpointSearchText = ""
    this.touchpointOptions = []
    this.fileUploadVm.selectedShop = null
    this.validateForm()
  }

  toggleTab(tab: string): void {
    this.activeTab = tab;
    this.switchMappingButtons(tab)
  }

  switchMappingButtons(mappings) {
    if (mappings === "existing_file_mapping") {
      this.fileUploadVm.isExistingMapping = true;
      // this.initializeDefaults();
      this.fileUploadVm.newConfigName = "";
    }
    else if (mappings === 'new_file_mapping') {
      this.fileUploadVm.isExistingMapping = false;
      this.fileUploadVm.fileData.selectedConfig = '';
    }
  }

  // Toggle dropdowns
  toggleDropdown(type: string) {
    if (type === 'touchpoint') {
      this.isTouchpointDropdownOpen = !this.isTouchpointDropdownOpen;
    } else if (type === 'fileMapping') {
      this.isFileMappingDropdownOpen = !this.isFileMappingDropdownOpen;
    }
  }

  onDropdownBlur(header: string): void {
    this.dropdownFocusState[header] = false;
  }

  isDropdownOpen(header: string): boolean {
    return this.dropdownFocusState[header];
  }
  onDropdownClick(header: string): void {
    this.dropdownFocusState[header] = !this.dropdownFocusState[header];
  }

  // Select option for File Mapping
  selectFileMapping(value: any) {
    this.selectedFileMapping = this.fileMapConfig.find(item => item?.value === value);
    this.configs = this.afpConfigs[value]
    this.isFileMappingDropdownOpen = false;
  }

  onFileSelect(event: Event): void {
    this.initializeDefaults()
    let input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      if (this.isValidFileExtension(input.files[0])) {
        this.fileName = input.files[0].name;
        this.fileUploadVm.fileToUpload = input.files[0]
      } else {
        this.displayError("File extension not supported");
        input.value = "";
      }

      // this.showPreview = true;
    } else {
      this.fileName = '';
      this.showPreview = false;
    }
  }
  isValidFileExtension(file) {
    const validExtensions = ['csv', 'xlsx', 'xls'];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    return validExtensions.includes(fileExtension);
  }
  deleteFile(): void {
    this.fileName = '';
    this.showPreview = false;
    (document.getElementById('file-upload') as HTMLInputElement).value = '';
    this.initializeDefaults()
  }

  getAFPConfigs() {
    let brand_id = Helpers.brandDetails?._id;
    this._outboxService.getAfpConfigs(brand_id).subscribe((res) => {
      if (res?.data?.afp_configs) {
        this.afpConfigs = res.data.afp_configs;

        this.fileMapConfig = Object.keys(this.afpConfigs).map(key => ({
          label: key,
          value: key
        }));

      } else if (res?.data?.code.toString() == "23") {
        // this._toast.showPopup('ERROR', '', "Afp Configs does not exists", 5000);
        this.toggleTab("new_file_mapping");
      } else {
        this.displayError("Invalid response structure")
        this.fileMapConfig = [];
      }
    }, (error) => {
      this.displayError("Error fetching AFP Configs")
    });
  }
  getFormData() {
    const formData = new FormData();
    formData.append('configs', JSON.stringify(this.configs))
    formData.append('brand_id', this.brandDetail?._id);
    formData.append('request_mode', this.request_mode);
    if (this.fileUploadVm.fileToUpload instanceof Blob) {
      formData.append('file_name', this.fileUploadVm.fileToUpload, this.fileName)
    }
    if (this.fileUploadVm.isExcludedFromAnalytics) {
      formData.append('is_excluded_from_analytics', this.fileUploadVm.isExcludedFromAnalytics)
    }
    if (!this.fileUploadVm.isExistingMapping) {
      formData.append('config_name', this.fileUploadVm?.newConfigName)
    }
    return formData;
  }


  showUploadHistory() {
    this.uploadHistoryComponent.initializeDefaults();
    this.uploadHistoryComponent.getUploadHistory();
    this.isUploadHistoryVisible = true;
  }
  closeUploadHistory() {
    this.isUploadHistoryVisible = false;
  }

  showAfpConfig() {
    this.isAfpConfigVisible = true;
  }
  closeAfpConfig() {
    this.isAfpConfigVisible = false;
    this.outboxAfpConfigurationComponent?.resetAfpConfig?.();
  }


  loadParsedFile() {
    // this._fileUploadService.getAllConfigurations(this.brandDetail?._id).subscribe(res => {
    //   this.fileUploadVm.configurations = res?.data?.afp_configs;
    // })
    // if (this.fileUploadVm.touchpointDataFromOrgNode) {
    //   this.fileUploadVm.shops = [this.fileUploadVm.touchpointDataFromOrgNode];
    //   this.fileUploadVm.selectedShop = this.fileUploadVm.touchpointDataFromOrgNode.app_id;
    //   let general_settings = {
    //     "shouldNotify": true
    //   };
    //   if (this.fileUploadVm.selectedShop) {
    //     general_settings["app_id"] = this.fileUploadVm.selectedShop;
    //     this.hasTouchpointInfo = true;
    //   }
    // }
    this.fileUploadVm.configMismatch = false;
    const files = this.fileUploadVm.fileToUpload;
    this.loadMappingOptions();
    if (!files || files?.length === 0) {

      this.fileUploadVm.errorMessage = 'No file selected.';
      return;
    }

    if (this.fileUploadVm.fileData.selectedConfig == "") {
      // this.fileUploadVm.switchMappingButtons('new');
    }
    this.fileUploadVm.fileData = {
      "files": files,
      "new_mappings": {},
      "selectedConfig": this.fileUploadVm.fileData.selectedConfig
    }
    this.fileUploadVm.fileData.fileHeaders = [];
    if (files) {

      const f = files;
      let mimeType = f?.type?.trim() || '';  // Ensure mimeType is always defined

      // Check file extension
      const ext = this._fileUploadService.checkFileExtension(f.name);


      // const ext = this._fileUploadService.checkFileExtension(files.name);

      if (!ext) {
        this.fileUploadVm.errorMessage = 'File extension not supported';
        return;
      }


      // // fix for window Machine
      if ((!mimeType || (mimeType && (mimeType).trim().length == 0)) && ext == '.csv') {
        mimeType = "text/csv";
      }
      // // If the file is of type xlsx or xls
      if ((mimeType == "text/csv" || (mimeType == 'application/vnd.ms-excel')) && ext == '.csv') {

        this._fileUploadService.parseCSV(f).then(result => {
          if (result.data) {
            this.processFile(result.data, () => {
              this.showPreview = true;
            });
          } else if (result.error) {
            // this.errorMessage = result.error; 
          }
        })
      } else if (mimeType != "text/csv" && ext != '.csv') {

        const reader = new FileReader();
        reader.onload = (e) => {
          const arrayBuffer = e.target?.result as ArrayBuffer;
          if (!arrayBuffer) {
            this.fileUploadVm.errorMessage = "Error while reading the file: File is empty";
            return;
          }

          // Convert ArrayBuffer to binary string
          const binaryString = new Uint8Array(arrayBuffer)
            .reduce((acc, byte) => acc + String.fromCharCode(byte), "");

          const workbook = XLSX.read(binaryString, { type: 'binary' });
          if (!workbook || workbook.SheetNames.length === 0) {
            this.fileUploadVm.errorMessage = 'Error: No sheets found in the Excel file.';
            return;
          }

          const sheetName = workbook.SheetNames[0]; // First sheet only
          const sheet = workbook.Sheets[sheetName];

          if (!sheet["!ref"]) {
            this.fileUploadVm.errorMessage = `Sheet ${sheetName} is empty`;
            return;
          }

          let csv = this._xlsxUtilsService.sheetToCsv(sheet).trim();
          if (!csv) {
            this.fileUploadVm.errorMessage = "Error while reading the file: File is empty";
            return;
          }

          // Convert CSV string to a Blob
          const csvBlob = new Blob([csv], { type: "text/csv" });

          // Convert Blob to File (if required by parseCSV)
          const csvFile = new File([csvBlob], "data.csv", { type: "text/csv" });

          // Parse CSV data from Excel
          this._fileUploadService.parseCSV(csvFile).then(result => {
            if (result.data) {
              this.processFile(result.data, () => {
                this.showPreview = true;
              });
            } else if (result.error) {
              this.fileUploadVm.errorMessage = result.error;
            }
          });
        };

        reader.readAsArrayBuffer(f);

      }
      else {
        this.displayError('File extension not supported');
      }
    }
    // 

  }

  processFile(csv: any, callback: Function): void {
    let fileHeaders = this.preProcessHeaders(this.trimComma(csv[0].toString()).split(','));
    this.fileUploadVm.fileData.fileHeaders = fileHeaders;
    // this.initializeDefaults();
    this.fileUploadVm.fileData.tagList = this.createTags(fileHeaders);
    let valid = this.validateFileHeaders(fileHeaders);
    callback();
    this.fileUploadVm.headerSelect = this.fileUploadVm.fileData.fileHeaders.reduce((acc, curr) => {
      acc[curr] = "";
      return acc;
    }, {})
  }

  preProcessHeaders(headers: string[]): string[] {
    return headers.map(header => header.replace(/\./g, '_'));
  }

  validateFileHeaders(headers: string[]): { name?: string, error?: string } | null {
    const headersFound = new Set();

    for (const header of headers) {
      if (header.trim() == "")
        return this.displayError('Empty column names');
      const tag = this.createTags([header])[header];
      if (headersFound.has(tag))
        return this.displayError('Duplicate columns found');
      headersFound.add(tag);
    }
    return this.findMatchingConfig(headers);
  }

  loadMappingOptions(): void {
    const commonFields = [
      { text: "Customer Names", id: "name" },
      { text: "Customer Emails", id: "userEmail" },
      { text: "Customer Phone Numbers (India)", id: "userPhone" },
      { text: "Customer WhatsApp Numbers (India)", id: "userWhatsapp" },
      { text: "Customer Id", id: "customer_id" },
      { text: "Dedupe Parameter (Unmasked)", id: "tag_private_dedup_field" },
      { text: "Saved as Time in hrs:min:sec", id: "tag_time_iso" },
      { text: "Saved as Dates in YYYY/MM/DD format", id: "date-iso" },
      { text: "Saved as Dates in DD/MM/YYYY format", id: "date" },
      { text: "Saved as Dates in YYYY/MM/DD HH:mm format", id: "date-time-iso" },
      { text: "Saved as Dates in DD/MM/YYYY HH:mm format", id: "date-time" },
      { text: "Preferred Language for Notification(Only one language)", id: "tag_private_language" },
      { text: "Preferred Languages for Conversation(Multiple Languages, comma separated)", id: "tag_private_language_options" }
    ];

    // Add common fields
    this.allMappingOptions = [...commonFields];

    // Add dynamic fields based on selectedShop
    if (!this.fileUploadVm.selectedShop?.app_id) {
      this.allMappingOptions.push({ text: "Touchpoints", id: "shopId" });
    }

    // Add customer phone and WhatsApp numbers (Rest)
    this.allMappingOptions.push(
      { text: "Customer Phone Numbers (Rest)", id: "userPhone-int", tooltip: "Phone numbers should start with '+' ex: +61, +1" },
      { text: "Customer WhatsApp Numbers (Rest)", id: "userWhatsapp-int", tooltip: "WhatsApp numbers should start with '+' ex: +61, +1" }
    );

    // Function to get hierarchy level name
    const getHierarchyLevelName = (hierarchyName: string, index: number): string => {
      return `${hierarchyName} (${this.brandDetail?.hierarchy_list[hierarchyName][index]})`;
    };

    // Adding dynamic hierarchy fields
    if (this.brandDetail?.is_single_touchpoint_setup && this.brandDetail?.hierarchy_list && this.brandDetail?.hierarchy_list_alias) {
      try {
        Object.keys(this.brandDetail?.hierarchy_list_alias).forEach(hierarchy => {
          const hierarchyAliasDetail = this.brandDetail?.hierarchy_list_alias[hierarchy];
          const hierarchyListDetail = this.brandDetail?.hierarchy_list[hierarchy];
          if (hierarchyListDetail && hierarchyAliasDetail?.values && hierarchyAliasDetail?.values.length) {
            hierarchyListDetail.forEach((_, index) => {
              this.allMappingOptions.push({
                text: getHierarchyLevelName(hierarchy, index),
                id: `tag_private_group_${hierarchyAliasDetail?.values[index]}`
              });
            });
          }
        });

        // Fixed fields (Ref Id-11405190611LP)
        this.allMappingOptions.push(
          { text: "Hierarchy Unique Key", id: "tag_private_group_hierarchy_0_id" },
          { text: "Has Hierarchy Data", id: "has_hierarchy_data" }
        );
      } catch (e) {
        this.displayError("Error processing hierarchy data.")
        console.error("Error processing hierarchy data:", e);
      }
    }

    this.fileUploadVm.currentMappingOptions = [...this.allMappingOptions];
  }

  updateMappingDropdownOptions(header) {
    const waTargetIds = ["userWhatsapp", "userWhatsapp-int"];
    if ((this.fileUploadVm?.headerSelect.hasOwnProperty(header) || header == 'same_whatsapp_number') && this.fileUploadVm?.currentMappingOptions?.length) {
      let values = Object.values(this.fileUploadVm.headerSelect)
      this.fileUploadVm.currentMappingOptions.forEach(item => {
        if (values.includes(item.id)) {
          item.disabled = true;
        } else if (waTargetIds.includes(item.id) && this.fileUploadVm?.isWhatsappSameAsPhone) {
          item.disabled = true
        } else {
          item.disabled = false;
        }
        if (values.includes("userPhone-int") && item.id == "userPhone") {
          item.disabled = true
        }
        if (values.includes("userPhone") && item.id == "userPhone-int") {
          item.disabled = true
        }
      })
      for (let key in this.fileUploadVm.headerSelect) {
        if (this.fileUploadVm?.isWhatsappSameAsPhone && this.fileUploadVm.headerSelect[key] === "userWhatsapp") {
          this.fileUploadVm.headerSelect[key] = "";
        }
      }
      this.createConfiguration();
      this.validateForm();
    }
  }

  findMatchingConfig(headers: string[]): { name?: string, error?: string } | null {
    if (!this.afpConfigs) return null;
    const configList = this.fileUploadVm.fileData.selectedConfig != "" ? [this.fileUploadVm.fileData.selectedConfig] : this.afpConfigs;

    for (let configName in configList) {
      const configData = this.afpConfigs[configName];
      const touchpoint = configData.general_settings?.app_id;
      const configHeaders = configData.validations.column_list.map(h => h.toLowerCase().trim());

      if (headers.length === configHeaders.length &&
        this.fileUploadVm.selectedShop?.app_id === touchpoint &&
        headers.every(h => configHeaders.includes(h.toLowerCase().trim()))) {
        this.selectFileMapping(configName);
        this.isMappingDropdownDisabled = true;
        this.openModal("matching_config");
        this.toggleTab('existing_file_mapping');
        return { name: configName };
      } else {
        this.toggleTab('new_file_mapping');
      }
    }
    return { error: 'No matching config found' };
  }

  openModal(name: string) {
    this.modalName = name;
    if (name == "matching_config") {
      this.modalHeader = "Matching Configuration Found!";
      this.modalBody = "The columns in the file match the " + this.selectedFileMapping?.value + " configuration. Do you want to proceed?"
    } else if (name == "default_config") {
      this.modalHeader = "Add As Default?";
      this.modalBody = "Do you want to add this configuration to default configuration for all Touchpoints?"
    }
    this.showModal = true;
  }

  confirmAction() {
    if (this.modalName == "matching_config") {
      this.validateForm();
    } else if (this.modalName == "default_config") {
      this.fileUploadVm.isDefaultConfig = true;
      this.saveConfigAndUploadFile(this.recaptchaToken);
      this.recaptchaToken = null;
    }
    this.showModal = false;
  }

  abortAction() {
    if (this.modalName == "matching_config") {
      this.configs = {};
      this.selectedFileMapping = null;
      this.toggleTab('new_file_mapping')
      this.validateForm();
    } else if (this.modalName == "default_config") {
      this.fileUploadVm.isDefaultConfig = false;
      this.saveConfigAndUploadFile(this.recaptchaToken);
      this.recaptchaToken = null;
    }
    this.showModal = false;
  }

  createTags(headers: string[]): Record<string, string> {
    return headers.reduce((tags, header) => {
      const formattedTag = `tag_${header.toLowerCase().trim().replace(/ /g, '_')}`;
      tags[header] = formattedTag;
      return tags;
    }, {} as Record<string, string>);
  }

  // enableButton(buttonId: string): void {
  //   // (document.getElementById(buttonId) as HTMLButtonElement).disabled = false;
  // }

  // enableFileUploadButtons(): void {
  //   ['configListDropdown_settings', 'upload_input', 'btnUploadFile'].forEach(id => this.enableButton(id));
  // }

  displayError(message: string): null {
    this._toast.showPopup('ERROR', 'Error', message, 5000);
    return null;
  }

  trimComma(str: string): string {
    const commaCode = ','.charCodeAt(0);
    let output = '';
    let count = str.length;
    let len = count;
    let st = 0;
    let off = 0;
    let val = str;

    while (st < len && val[off + st].charCodeAt(0) <= commaCode) {
      st++;
    }
    while (st < len && val[off + len - 1].charCodeAt(0) <= commaCode) {
      len--;
    }
    if (st > 0 || len < count) {
      output = str.substring(st, len);
    } else {
      output = str;
    }
    return output;
  }

  createConfiguration() {
    this.dataTypes = {}
    this.hasPhone = false;
    this.hasEmail = false;
    this.hasTouchpointInfo = false;
    this.hasCustomerId = false;
    Object.entries(this.fileUploadVm?.headerSelect || {}).forEach(([key, value]) => {
      // if (value === "") {
      //   let formattedKey = key.toLowerCase().replace(/ /g, "_").replace(/-/g, "_");
      //   this.fileUploadVm.headerSelect[key] = "tag_" + formattedKey;
      // }
      if (value == "date-iso" || value == "date" || value == "date-time" || value == "date-time-iso") {
        this.dataTypes[key] = value
      } else if (value == "tag_time_iso") {
        this.fileUploadVm.fileData.tagList[key] = value;
        this.dataTypes["tag_time_iso"] = "time";
      } else if (value == "userPhone") {
        // To assign the value into  fileUploadVm.fileData.tagList
        this.fileUploadVm.fileData.tagList[key] = value;
        this.dataTypes["userPhone"] = "integer";
        this.hasPhone = true;
      } else if (value == "userWhatsapp") {
        this.fileUploadVm.fileData.tagList[key] = value;
        this.dataTypes["userWhatsapp"] = "integer";
        this.hasPhone = true;
      } else if (value == "userPhone-int") {
        this.fileUploadVm.fileData.tagList[key] = "userPhone";
        this.dataTypes["userPhone"] = "phone_international";
        this.hasPhone = true;
      } else if (value == "userWhatsapp-int") {
        this.fileUploadVm.fileData.tagList[key] = "userWhatsapp";
        this.dataTypes["userWhatsapp"] = "phone_international";
        this.hasPhone = true;
      } else if (value == "userEmail") {
        this.fileUploadVm.fileData.tagList[key] = value;
        this.hasEmail = true;
      } else if (value == "shopId") {
        // To assign the value into  fileUploadVm.fileData.tagList
        this.fileUploadVm.fileData.tagList[key] = value;
        this.hasTouchpointInfo = true;
      } else if (value == "customer_id") {
        // To assign the value into  fileUploadVm.fileData.tagList
        this.fileUploadVm.fileData.tagList[key] = value;
        this.hasCustomerId = true;
      } else {
        this.fileUploadVm.fileData.tagList[key] = value;
      }
      // isWhatsappSameAsPhone = false, when whatsapp same as phone selected but primary phone is not mapped
      // TODO
      // if (this.fileUploadVm.isWhatsappSameAsPhone && !this.hasPhone) {
      //   this.fileUploadVm.isWhatsappSameAsPhone = false;
      // }

    });
    this.configs = {
      "general_settings": {
        "shouldNotify": true
      },
      "mappings": this.fileUploadVm?.headerSelect,
      "data_types": this.dataTypes,
      "validations": {
        "column_list": this.fileUploadVm?.fileData?.fileHeaders
      },
      "email_settings": {
        "from": "litmusWorld File Parser",
        "to_list": [
          "litmus-processing@litmusworld.com"
        ]
      },
      "is_whatsapp_number_same_as_phone_number": this.fileUploadVm.isWhatsappSameAsPhone,
      "brand_id": this.brandDetail?._id,
      "app_id_prefix": this.brandDetail?.app_id_prefix,
      "is_excluded_from_analytics": this.fileUploadVm.isExcludedFromAnalytics
    }
    if (this.fileUploadVm.selectedShop && this.fileUploadVm.selectedShop?.app_id) {
      this.configs["general_settings"]["app_id"] = this.fileUploadVm.selectedShop["app_id"];
      if (this.fileUploadVm.isDefaultConfig) {
        this.configs['is_default'] = true;
      }
    }
    const params = {
      "configs": this.configs,
      "brand_id": this.brandDetail?._id,
      "config_name": this.fileUploadVm.newConfigName
    }
    return params;
  }

  validateMappingName() {
    if ((this.fileUploadVm.newConfigName != "" && !this.fileUploadVm.newConfigName.match(/[^A-Za-z0-9_-]/g))) {
      this.isValidConfigName = true;
    } else {
      this.isValidConfigName = false;
    }
    this.validateForm()
  }

  validateForm() {
    // with existing mapping
    if (this.fileUploadVm.isExistingMapping) {
      if (this.fileUploadVm.fileToUpload instanceof Blob) {
        this.isFormValid = true;
      }
      else {
        this.isFormValid = false
      }
    }
    // with new mapping
    else {
      this.fileUploadVm.newConfigName = this.fileUploadVm.newConfigName.trim()
      if ((this.hasPhone || this.hasEmail || this.hasCustomerId) &&
        (this.hasTouchpointInfo || (this.fileUploadVm.selectedShop?.app_id)) &&
        (this.fileUploadVm.newConfigName != "" && !this.fileUploadVm.newConfigName.match(/[^A-Za-z0-9_-]/g))) {
        this.isFormValid = true;
      }
      else {
        this.isFormValid = false;
      }
    }
  }

  saveConfigAndUploadFile(recaptchaToken?: string) {
    let params = this.createConfiguration();
    this.isFormValid = false;
    if (params.configs && this.fileUploadVm?.headerSelect) {
      params.configs['mappings'] = this._outboxService.createTags(this.fileUploadVm?.headerSelect);
    }
    this._outboxService.postConfiguration(params).subscribe(response => {
      response = response?.data;
      if (response && response.code == 0) {
        this._toast.showPopup('SUCCESS', "Configuration Saved Successfully", "Configuration \"" + this.fileUploadVm.newConfigName + "\" saved successfully", 5000);
        this.getAFPConfigs();
        let formData = this.getFormData();
        if (recaptchaToken) {
          formData.append('g_recaptcha_response_v3', recaptchaToken);
        }
        this._outboxService.validateUserAnduploadFile(formData).subscribe(res => {
          if (res.data.code.toString() == "0") {
            this._toast.showPopup('SUCCESS', 'Success', 'Your file has been uploaded.', 5000);
          } else {
           this.displayError(this.errorMsgs[res.data.code?.toString()]?.text || 'An unexpected error occurred.');
          }
          this.fileUploadVm.isExcludedFromAnalytics = false;
          this.initializeDefaults();
          this.clearTouchpointText();
          this.deleteFile();
          this.requestCreationComponent.closeNewRequestPanel();
        })
      } else if (response && response.code == 401) {
        this.displayError('Config already exists.');
      } else if (response && response.code == 1) {
        this.displayError('Internal Error');
      } else if (response && response.code == 202) {
        this.displayError('Project does not exists.');
      } else if (response && response.code == 2) {
        this.displayError('Required parameters not sent.');
      } else {
        this.displayError('Something went wrong!');
      }
    })
  }

  triggerRequest() {
    if (!this.isFormValid) {
        return;
    }
    const token = "litmusworld_internal"
      if (token) {
        if (this.activeTab == "existing_file_mapping") {
          let formData = this.getFormData()
          this.isFormValid = false;
          formData.append('g_recaptcha_response_v3', token);
          this._outboxService.validateUserAnduploadFile(formData).subscribe(res => {
            if (res.data.code.toString() == "0") {
              this._toast.showPopup('SUCCESS', 'Success', 'Your file has been uploaded.', 5000);
            } else {
              this.displayError(this.errorMsgs[res.data.code?.toString()]?.text || 'An unexpected error occurred.');
              this._toast.showPopup('ERROR', '', "An unexpected error occurred.", 5000);
            }
            this.fileUploadVm.isExcludedFromAnalytics = false;
            this.initializeDefaults();
            this.clearTouchpointText();
            this.deleteFile();
            this.requestCreationComponent.closeNewRequestPanel();
          })
        } else if (this.activeTab == "new_file_mapping") {
          if (this.fileUploadVm.selectedShop?.app_id) {
            this.recaptchaToken = token;
            this.openModal("default_config");
          } else {
            this.saveConfigAndUploadFile(token);
          }
        } else {
          this.displayError('Invalid tab!');
        }
      } else {
        this.displayError('Please try again after some time');
      }
  }

  // triggerRequestV2 is created to generate and validate recaptcha.
  triggerRequestV2() {
    this.recaptchaV3Service.execute('importantAction').subscribe((token: string) => {
      if (token) {
        if (this.activeTab == "existing_file_mapping") {
          let formData = this.getFormData()
          this.isFormValid = false;
          formData.append('g_recaptcha_response_v3', token);
          this._outboxService.validateUserAnduploadFile(formData).subscribe(res => {
            if (res.data.code.toString() == "0") {
              this._toast.showPopup('SUCCESS', 'Success', 'Your file has been uploaded.', 5000);
            } else {
              this.displayError(this.errorMsgs[res.data.code?.toString()]?.text || 'An unexpected error occurred.');
              this._toast.showPopup('ERROR', '', "An unexpected error occurred.", 5000);
            }
            this.fileUploadVm.isExcludedFromAnalytics = false;
            this.initializeDefaults();
            this.clearTouchpointText();
            this.deleteFile();
            this.requestCreationComponent.closeNewRequestPanel();
          })
        } else if (this.activeTab == "new_file_mapping") {
          if (this.fileUploadVm.selectedShop?.app_id) {
            this.recaptchaToken = token;
            this.openModal("default_config");
          } else {
            this.saveConfigAndUploadFile(token);
          }
        } else {
          this.displayError('Invalid tab!');
        }
      } else {
        this.displayError('Please try again after some time');
      }
    });
  }

  cancelRequest() {
    this.fileUploadVm.isExcludedFromAnalytics = false;
    this.deleteFile()
    this.clearTouchpointText();
    this.initializeDefaults();
    this.requestCreationComponent.closeNewRequestPanel()
  }

}